export default __webpack_public_path__ + "static/media/client2.4ec3fa64.webp";